<template>
    <div class="img-view" v-show="isShowImageModal" @click="toggleModal(url)">
            <div style="width:100%">
                <img :src="imgSrc" width="100%" />
            </div>
    </div>
</template>

<script>
    export default {
        props: ['url','isShowImageModal'],
        computed: {
            imgSrc(){
                const aliyunCDN = /\.maizuo\.com/
                if (aliyunCDN.test(this.url)) {
                    if (this.url.indexOf('?') !== -1) {
                    return `${this.url}&x-oss-process=image/quality,Q_70`
                    }
                    return `${this.url}?x-oss-process=image/quality,Q_70`
                }
                return ''
            }
        },
        methods: {
            toggleModal(url) {
                this.$emit('toggleModal', url)
            }
        }
    }
</script>

<style lang="less">
.img-view {
    height: 100%;
    width: 100%;
    // background: rgba(0, 0, 0, .6);
    background: rgb(0, 0, 0);    
    position: fixed;
    top: 0;
    z-index: 1000;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>